import { BrowserInfo } from "./browser";
import { ElectronFunctions } from "./electron/electron";
import {v4 as uuid} from "uuid";
import { PdfImages } from "./pdf-images";

export class PdfViewer {
	private pdfBlob:Blob | null= null;
	private url:string = "";
	private electronFileName:string = "";
	private images:PdfImages | null = null;
	private imageUrls:string[] = [];

	public constructor(){
	}

	public setPdfBlob(blob:Blob) {
		this.pdfBlob = blob;
	}

	public setImages(images:PdfImages){
		this.images = images;
	}

	public async open():Promise<void>{
		if (BrowserInfo.isElectron()){
			await this.openElectron();
		}else if(this.shouldFetchAsImage()){
			this.openAsImage();
		}else{
			this.openNormal();
		}
	}

	private openNormal(){
		if (!this.pdfBlob) return;
		this.url = URL.createObjectURL(this.pdfBlob);
	}

	private async openElectron(){
		if (!this.pdfBlob) return;
		this.electronFileName = `${uuid()}.pdf`;
		let fileTemp = new File([this.pdfBlob], this.electronFileName, {lastModified: new Date().getTime(), type: this.pdfBlob.type});
		let file = fileTemp as File;
		await ElectronFunctions.saveTempFile(file);
		this.url = ElectronFunctions.getPdfViewerUrl(this.electronFileName);
	}

	private openAsImage(){
		if (!this.images) return;
		for (let image of this.images.Images){
			this.imageUrls.push(URL.createObjectURL(image.Image));
		}
	}

	public close(){
		if (BrowserInfo.isElectron()){
			this.closeElectron();
		}else{
			this.closeNormal();
		}
		this.closeImages();
	}

	private closeNormal(){
		if (!this.url) return;
		URL.revokeObjectURL(this.url);
	}

	private closeImages(){
		for (let url of this.imageUrls) {
			URL.revokeObjectURL(url);
		}
	}

	private closeElectron(){
		if (!this.electronFileName) return;
		ElectronFunctions.deleteTempFile(this.electronFileName);
	}

	public getImageUrls():string[]{
		return [...this.imageUrls];
	}

	public getURL():string{
		if (!this.url) return "";
		let zoomLevel = window.innerWidth < 1000 ? 75 : 100;
		return this.url + "#zoom="+zoomLevel;
	}

	public shouldFetchAsImage():boolean {
		return BrowserInfo.isMobile() || BrowserInfo.isIPadOS();
	}
}